<template>
  <section class="chat-lobby">
    <div class="loading-spinner" v-if="isLoading">
      <base-spinner></base-spinner>
    </div>

    <div v-if="!isLoading">   
      <ul v-if="RoomLists.length > 0">
        <li
          v-for="(chatroomList, index) in RoomLists"
          :key="index"
          @click="chatroomLink(chatroomList.id)"
        >
          <div class="rank">
            <span class="rank_number">{{ index + 1 }}</span>
          </div>
          <div class="cont_wrap">
            <div class="cont">
              <div class="icon_rect">
                <div class="icon">
                  <img
                    :src="
                      `${$store.state.serverPath}${chatroomList.icon}`
                    "
                    width="55"
                  />
                </div>
              </div>
              <div class="summary">
                <div class="title">
                  {{ chatroomList.title }}
                </div>
                <div class="subtitle">
                  {{ chatroomList.subtitle }}
                </div>
                <div class="userinfo">
                  <span>{{ chatroomList.user.nic }}</span> | 1일전 | 전체 | 1,132
                  / 1,200
                </div>
              </div>
            </div>
          </div>
        </li>     
      </ul>
      <div v-else class="empty">
        현재 생성된 방이 없습니다.
      </div>
    </div>
  </section>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
export default {
  props:{
    isMobile:{
      type:Boolean,
      default:false
    },
    newChatRoom:{
      default:false
    }
  },
  data() {
    return {
      isLoading: false,
      RoomLists: "",
    };
  },
  mixins:[
    auth
  ],
  created() {
    this.fetchLists();
  },  
  computed:{
    cknewRoom()
    {
      return this.newChatRoom;
    }
  },
  watch:{
    cknewRoom(data)
    {
      //alert(roomid);
      if(data)
      {
        // alert('신규방생성 테스트');
        this.fetchLists('new');
      }
    }
},
  methods: {
    async chatroomLink(room_id) {     
      //아이템 유무 판단
      // const ckitem =  await this.ckItem('chat_free','pop',room_id);
      // if(!ckitem){                
      //     return;                
      // }
      if(!this.isAuth)
      {
        if(confirm('로그인이 필요 합니다.'))
        {
          if(this.isMobile)
          {
            this.$router.push({ name: 'm_Login', params: { prevroute: 'm_ChatLobby' }})
          }else{
            this.$router.push({ name: 'auth_login', params: { prevroute: 'chat_Lobby' }})
          }         
        }
      }else{
        let url="";
        if(this.isMobile)
        {
          url='/m_chat/';
        }else{
          this.$emit("join-room");
          url='room/';
        }      
        this.$router.push({
          path: url + room_id
        });
      }
      
    },
    async fetchLists(newroom) {
      this.isLoading = true;
      try {
        let response = "";
        if (this.$store.state.chat.roomList && newroom === null) {
          response = await this.$store.getters["chat/getChatroomList"];
          console.log('여기로 타는지 체크',this.$store.state.chat.roomList)
        } else {
          response = await this.$store.dispatch("chat/fechChatroomList");

        }
        console.log('방리스트', response)
        this.RoomLists = response;
        //this.chatroomLists = response.data.reverse();
      } catch (error) {
        console.log(error.response);
      }
      this.isLoading = false;
    },
    
  },
};
</script>
<style lang="scss" scoped>
.empty{text-align: center;}
.chat-lobby {
  flex: 1 1 auto;
  height: 100%;
  overflow-y: scroll;
  width:100%;
  .loading-spinner{
      display:flex;
  }
  li:first-child {
    .rank {
      background: #ffb033;
      .rank_number {
        font-size: 70px;
        font-weight: bold;
        color: #fff;
      }
    }
    .cont_wrap {
      background: #ffb033;
    }
  }
  li:nth-child(2) {
    .rank {
      background: #0062d1;
      .rank_number {
        font-size: 50px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  li:nth-child(3) {
    .rank {
      background: #0062d1;
      .rank_number {
        font-size: 46px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  li:hover {
    border: 1px solid red;
  }
  li {
    display: flex;
    border-bottom: 1px solid #ededed;
    cursor: pointer;
    .rank {
      background-color: #e0e0e0;
      width: 70px;
      text-align: center;
      padding: 10px;
      .rank_number {
        font-size: 36px;
        color: #878787;
        font-family: Arial;
      }
    }
    .cont_wrap {
      width: 100%;
      padding: 10px 10px 10px 0;
      .cont {
        display: flex;
        background: #fff;
        padding: 10px;
        .icon_rect {
          .icon {
            background: #eee;
            width: 55px;
            height: 100%;
          }
        }
        .summary {
          font-size: 12px;
          padding-left: 15px;
          padding-top: 5px;
          .title {
            font-weight: 900;
          }
          .subtitle {
            padding-top: 10px;
          }
          .userinfo {
            color: #929292;
            padding-top: 10px;
            span {
              color: #292929;
              font-weight: 900;
            }
          }
        }
      }
    }
  }
}
</style>
